<script>
  import { _, locale, locales } from 'svelte-i18n';
  import { currentPage } from '@store/route-store';
  import { getConfig } from '@app/config';
  import EventList from '../smart/EventList.svelte';
  import { setNight, setDay, darkModeEnabled } from '@store/dark-mode-store';

  // See config.ts for interface
  export let header;
  export let modules;

  export let mobileControlsHidden = true;

  function toggleMobileControlsHidden() {
    if (mobileControlsHidden) {
      mobileControlsHidden = false;
    } else {
      mobileControlsHidden = true;
    }
  }

  function getFooterConfig(currentPage) {
    return getConfig().modules[currentPage.category].footer;
  }
</script>

<header class="header" lang="{$locale}">

  <div id="top" class="accessibility-shortcuts">
    <a href="#content-main" class="sr-only sr-only-focusable"> {$_('accessibility.skip_to_content')} </a>
  </div>

  <section class="header__top">
    <div class="header__top__mobile-controls--overlay {mobileControlsHidden ? 'header__top__mobile-controls--hidden' : '' }" aria-hidden="mobileControlsHidden">
      <div class="header__top__mobile-controls">
        {#if $currentPage != null && modules.events.enabled && modules.activities.enabled}
          <nav class="header__top__mobile-controls__navigation">
            <a
              class="header__top__mobile-controls__navigation__navlink {$currentPage.category === 'events' ? 'header__top__mobile-controls__navigation__navlink--active' : ''}"
              aria-current="{$currentPage.category === 'events' ? 'page' : ''}"
              href="/" on:click="{toggleMobileControlsHidden}">{$_('event_list.title')}</a>
            <a
              class="header__top__mobile-controls__navigation__navlink {$currentPage.category === 'activities' ? 'header__top__mobile-controls__navigation__navlink--active' : ''}"
              aria-current="{$currentPage.category === 'activities' ? 'page' : ''}"
              href="/activity" on:click="{toggleMobileControlsHidden}">{$_('activity_list.title')}</a>
          </nav>
        {/if}
        <div class="header__top__mobile-controls__modes">
          <div class="header__top__mobile-controls__modes__language">
            <select bind:value="{$locale}" aria-label="{$_('common.choose_language')}">
              {#each $locales as locale}
                <option value="{locale}">{locale}</option>
              {/each}
            </select>
          </div>
          <div class="header__top__mobile-controls__modes__theme">
            <button class="header__top__mobile-controls__modes__theme__button" on:click="{setDay}" aria-label="{$_('common.color_theme.light')}">
              <i class="header__top__mobile-controls__modes__theme__button__icon  fa fa-sun-o"></i>
            </button>
            <button class="header__top__mobile-controls__modes__theme__button header__top__mobile-controls__modes__theme__button--dark" on:click="{setNight}" aria-label="{$_('common.color_theme.dark')}">
              <i class="header__top__mobile-controls__modes__theme__button__icon fa fa-moon-o"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="header__top__logo">
      {#if $currentPage != null && modules.events.enabled && modules.activities.enabled}
        <a href="{
          (modules.events.enabled && $currentPage.category === 'events') ? '/' :
          (modules.activities.enabled && $currentPage.category === 'activities' ? '/activity' : '/')
        }">
          <img src="{$darkModeEnabled ? header.logo.dark.url : header.logo.light.url}" alt="{$_('common.frontpage')}" />
        </a>
      {:else}
        <a href="/">
          <img src="{$darkModeEnabled ? header.logo.dark.url : header.logo.light.url}" alt="{$_('common.frontpage')}" />
        </a>
      {/if}
    </div>

    <div class="header__top__mobilemenu">
      <button class="icon-button header__top__mobilemenu__toggle" on:click="{toggleMobileControlsHidden}">
        <i class="icon-button__icon {mobileControlsHidden ? 'fa fa-bars' : 'fa fa-times'}"></i>
        <span>
          {$_('common.menu')}
        </span>
      </button>
    </div>

    {#if $currentPage != null && modules.events.enabled && modules.activities.enabled}
      <div class="header__top__controls__navigation__wrapper">
        <nav class="header__top__controls__navigation">
          <a
            class="header__top__controls__navigation__navlink {$currentPage.category === 'events' ? 'header__top__controls__navigation__navlink--active' : ''}"
            aria-current="{$currentPage.category === 'events' ? 'page' : ''}"
            href="/">
            {$_('event_list.title')}
          </a>
          <a
            class="header__top__controls__navigation__navlink {$currentPage.category === 'activities' ? 'header__top__controls__navigation__navlink--active' : ''}"
            aria-current="{$currentPage.category === 'activities' ? 'page' : ''}"
            href="/activity">
            {$_('activity_list.title')}
          </a>
        </nav>
      </div>
    {/if}
    <div class="header__top__controls">
      <div class="header__top__controls__wrapper">
        <div class="header__top__controls__wrapper__theme-lang">
          <select class="header__top__controls__language" bind:value="{$locale}" aria-label="{$_('common.choose_language')}">
            {#each $locales as locale}
              <option value="{locale}">{locale}</option>
            {/each}
          </select>
          <div class="header__top__controls__theme">
            <button class="header__top__controls__theme__button" on:click="{setDay}" aria-current="{!$darkModeEnabled}" aria-label="{$_('common.color_theme.light')}" title="{$_('common.color_theme.light')}">
              <i class="header__top__controls__theme__button__icon fa fa-sun-o"></i>
            </button>
            <button class="header__top__controls__theme__button header__top__controls__theme__button--dark" on:click="{setNight}" aria-current="{$darkModeEnabled}" aria-label="{$_('common.color_theme.dark')}" title="{$_('common.color_theme.dark')}">
              <i class="header__top__controls__theme__button__icon fa fa-moon-o"></i>
            </button>
          </div>
        </div>
        <div class="header__top__controls__wrapper__add-link">
          {#if $currentPage != null}
            <a href="{getFooterConfig($currentPage).addLink.url}" target="_blank">
              {#if $currentPage.category === 'events'}
                {$_('common.add_event')}
              {:else if $currentPage.category === 'activities'}
                {$_('common.add_activity')}
              {/if}
            </a>
          {/if}
        </div>
      </div>
    </div>
  </section>
</header>
